module.exports = __webpack_public_path__ + "static/media/bg-glucose-test.48dacc79.png";